module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/pierata.f833408.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/pierata.jpg
// module id = 6Pb7
// module chunks = 0